__turbopack_context__.v({
  "attributesSkeleton": "styles-module__bqb42a__attributesSkeleton",
  "modalProductListContainer": "styles-module__bqb42a__modalProductListContainer",
  "scrollableItemRow": "styles-module__bqb42a__scrollableItemRow",
  "seeMoreText": "styles-module__bqb42a__seeMoreText",
  "segment": "styles-module__bqb42a__segment",
  "segments": "styles-module__bqb42a__segments",
});
